import BigNumber from 'bignumber.js'
import erc20ABI from 'config/abi/erc20.json'
import sousChefABI from 'config/abi/sousChef.json'
import poolsConfig from 'config/constants/pools'
import {getAddress} from 'utils/addressHelpers'
import {getMasterchefContract} from 'utils/contractHelpers'
import multicall from 'utils/multicall'
import {getWeb3} from 'utils/web3'

// Pool 0, Cake / Cake is a different kind of contract (master chef)
// BNB pools use the native BNB token (wrapping ? unwrapping is done at the contract level)
const nonBnbPools = poolsConfig.filter((p) => p.stakingToken.symbol !== 'MATIC')
const bnbPools = poolsConfig.filter((p) => p.stakingToken.symbol === 'MATIC')
const nonMasterPools = poolsConfig.filter((p) => p.sousId !== 0)
const masterChefContract = getMasterchefContract()
const web3 = getWeb3()

export const fetchPoolsAllowance = async (account) => {
  const calls = nonBnbPools.map((p) => ({
    address: getAddress(p.stakingToken.address),
    name: 'allowance',
    params: [account, getAddress(p.contractAddress)],
  }))

  const allowances = await multicall(erc20ABI, calls)
  return nonBnbPools.reduce(
    (acc, pool, index) => ({...acc, [pool.sousId]: new BigNumber(allowances[index]).toJSON()}),
    {},
  )
}

export const fetchUserBalances = async (account) => {
  // Non BNB pools
  const calls = nonBnbPools.map((p) => ({
    address: getAddress(p.stakingToken.address),
    name: 'balanceOf',
    params: [account],
  }))
  const tokenBalancesRaw = await multicall(erc20ABI, calls)
  const tokenBalances = nonBnbPools.reduce(
    (acc, pool, index) => ({...acc, [pool.sousId]: new BigNumber(tokenBalancesRaw[index]).toJSON()}),
    {},
  )

  // BNB pools
  const bnbBalance = await web3.eth.getBalance(account)
  const bnbBalances = bnbPools.reduce((acc, pool) => ({...acc, [pool.sousId]: new BigNumber(bnbBalance).toJSON()}), {})

  return {...tokenBalances, ...bnbBalances}
}

export const fetchUserStakeBalances = async (account) => {
  const calls = nonMasterPools.map((p) => ({
    address: getAddress(p.contractAddress),
    name: 'userInfo',
    params: [p.sousId, account],
  }))
  const userInfo = await multicall(sousChefABI, calls)
  const stakedBalances = nonMasterPools.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: new BigNumber(userInfo[index].amount._hex).toJSON(),
    }),
    {},
  )

  // Cake / Cake pool
  const {amount: masterPoolAmount} = await masterChefContract.userInfo('0', account)

  return {...stakedBalances, 0: new BigNumber(masterPoolAmount.toString()).toJSON()}
}

export const fetchUserPendingRewards = async (account) => {
  const calls = nonMasterPools.map((p) => ({
    address: getAddress(p.contractAddress),
    name: 'pendingSirius',
    params: [p.sousId, account],
  }))
  const res = await multicall(sousChefABI, calls)
  const pendingRewards = nonMasterPools.reduce(
    (acc, pool, index) => ({
      ...acc,
      [pool.sousId]: new BigNumber(res[index]).toJSON(),
    }),
    {},
  )

  // Cake / Cake pool
  const pendingReward = await masterChefContract.pendingSirius('0', account)

  return {...pendingRewards, 0: new BigNumber(pendingReward.toString()).toJSON()}
}
